

import { Avatar, Box, Grid, Stack } from '@mui/material';
import CustomText from 'components/common/CustomText/CustomText';
import React, { useMemo } from 'react'
import useGlobalStyles from 'styles/globalStyles';
import { colors } from 'styles/colors';
import FolderIcon from '../../../assets/icons/registryicon.png';
import { dateToString } from 'common/utils';
import { useNavigate } from 'react-router-dom';
import RegistryOptions from '../RegistryItemOptions/RegistryItemOptions';
import { EBaseRegistriesPath } from 'common/constants';
import { useAuth } from 'context/AuthContext';

interface Props {
  item: any;
  refetch?: () => void;
  basePath: EBaseRegistriesPath
}

export default function RegistryItem({ item, refetch, basePath }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();


  const showOptions = useMemo(() => {
    return user?.id == item?.owner?.id;
  }, [user, item]);


  return (
    <Grid
      className={globalStyles.registryItem}
      p={1.5}
      size={{
        xs: 12,
        md: 6,
        lg: 4
      }}
      onClick={() => {
        navigate(`${item.id}`);
      }}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={1.5}
        >          <Box
            component='img'
            src={FolderIcon}
            height={55}
          />

          <Box>
            <CustomText
              text={item.name}
              fontSize={16}
              fontWeight={600}
            />

            <Stack
              direction={'row'}
              alignItems={'center'}
              spacing={1}
              my={0.5}
            >
              <Avatar
                src={item?.owner?.user_media?.image?.href_small}
                sx={{
                  height: 20,
                  width: 20,
                  bgcolor: colors.avatarBg,
                }}
              />
              <CustomText
                text={item.owner.name}
                fontSize={14}
                color={colors.secondary}
              />
            </Stack>

            <Box mt={0.8}>
              <CustomText
                text={dateToString(new Date(item.updated))}
                fontSize={14}
                color={colors.secondary}
              />
            </Box>
          </Box>
        </Stack>

        {showOptions && <Box
          onClick={(e) => {
            e.stopPropagation();
          }}
          alignSelf={'flex-start'}
        >
          <RegistryOptions registryId={item.id} registryName={item.name} refetch={refetch} />
        </Box>}
      </Stack>
    </Grid>
  )
}
